if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // optional: keep warn and error
  // console.warn = () => {};
  // console.error = () => {};
}